const autoNgTemplateLoaderTemplate1 = require('./volumeStoridgeInfo.html');

angular.module('shbdeployer.docker').component('volumeStoridgeInfo', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'VolumeStoridgeInfoController',
  bindings: {
    volume: '<',
  },
});
